export default __webpack_public_path__ + "static/media/fxInfo.6db606c8.mp3";